(function statisticsModuleDefinition() {
    'use strict';

    angular.module('StatisticsRRHH', ['ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'DoublyLinkedList'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function statisticsConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('statistics-rrhh-find', {
                    url: "/StatisticsRRHH/Find",
                    templateUrl: config.resourceUrl('/views/statistics/statistics-find.html'),
                    controller: 'StatisticsFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PAYCHECK READ')
                });
            }
        ]);
})();
